import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
import { EntityKind } from "../constants.js";
/** Bit 0 de `flags`: entidade com quem se conversa em vez de lutar. */
const FLAG_FRIENDLY = 1;
export function encodeEntityInfo(packet, writer = new BinaryWriter(64)) {
    writer.u8(ServerOp.EntityInfo).u16(packet.entities.length);
    for (const entity of packet.entities) {
        writer
            .u32(entity.id)
            .u8(entity.kind)
            .u8(entity.friendly ? FLAG_FRIENDLY : 0)
            .str8(entity.name);
    }
    return writer;
}
export function decodeEntityInfo(reader) {
    const count = reader.u16();
    const entities = new Array(count);
    for (let i = 0; i < count; i++) {
        const id = reader.u32();
        const rawKind = reader.u8();
        const flags = reader.u8();
        entities[i] = {
            id,
            kind: rawKind === EntityKind.Npc ? EntityKind.Npc : EntityKind.Player,
            friendly: (flags & FLAG_FRIENDLY) !== 0,
            name: reader.str8(),
        };
    }
    return { entities };
}
//# sourceMappingURL=entity-info.js.map